/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import TableRow from "../../Helpers/Table/TableRow";
import TableActions from "../../Helpers/Table/TableActions";
import { filtrationcontext } from "../../../context/Filtercontext";
import Empty from "../../Helpers/Empty/Empty";
import { toast } from "react-toastify";
import trans from "../../../utils";
export default function DriverTableBody({ data }) {
	const [tableData, setTableData] = useState([]);
	const { DriverssearchQuery, setTotalPages } = useContext(filtrationcontext);

	useEffect(() => {
		setTableData(data);
		setTotalPages(data?.totalPages);
	}, [data, DriverssearchQuery, setTotalPages]);
	if (data?.length === 0)
		return (
			<Empty
				title={trans("No Drivers Found")}
				subtitle={trans("Add your new driver now!")}
			/>
		);

	if (!tableData) {
		toast.error(trans("No Data Found, Please reload"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});
		return;
	}
	return (
		<>
			{tableData.map((i) => (
				<div key={i.id} className="table-row">
					<TableRow value={i.name} style="table-element-name ps-0" />
					<TableRow value={i.code ? i.code : "- - - - -"} />
					<TableRow value={i.idNo ? i.idNo : "- - - - -"} />
					<TableRow
						value={i.phoneNumber ? i.phoneNumber : "- - - - -"}
						style="table-element-phone"
					/>
					<TableRow value={i.address ? i.address : "- - - - -"} />
					<TableActions DriverId={i.id} />
				</div>
			))}
		</>
	);
}
